// extracted by mini-css-extract-plugin
export default {"contatoParte1":"ContatoParte1_contatoParte1__05E3N","btn":"ContatoParte1_btn__xkLi-"};